import React from 'react';
import { ReactComponent as CheckedSvgIcon } from 'assets/images/checked-icon.svg';
import SvgIcon from '@mui/material/SvgIcon';

const CheckedIcon = (props) => <SvgIcon component={CheckedSvgIcon} inheritViewBox {...props} htmlColor='transparent' />;

export default CheckedIcon;